import React from "react";
import { getAssets } from "@unisearch/helpers";
import SectionTitle from "../common/section_title";
import MentorCard from "@modules/admin/student/shared/mentor_card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import styles from "./mentor_list.module.scss";

export const MentorList = ({ mentor }) => {
  return (
    <section className={styles.section_mentor_list}>
      <div className="container">
        <SectionTitle shadow_text="OUR MENTORS" title="Mentors"></SectionTitle>

        <Grid container spacing={2}>
          {mentor.length > 0 &&
            mentor.map((item) => (
              <Grid item xs={12} md={4} lg={3} key={item.id}>
                <MentorCard
                  border
                  iconVerified={item.iconVerified}
                  avatar={item.avatar || getAssets("assets/images/avatar.png")}
                  name={`${item.firstName}  ${item.lastName}`}
                  country={`${item.city.name} , ${item.country.name}`}
                  university={item.universityName ?? ""}
                  designation={item.designation ?? ""}
                  link={"/signin"}
                />
              </Grid>
            ))}
        </Grid>
      </div>
    </section>
  );
};

export default MentorList;
